import {
    AfterViewInit,
    Component,
    OnInit
} from '@angular/core';
import {
    ControlService,
    IconService, InputBoxService,
    SubtitlesService,
} from "../../../core";
import {MenuElementType15, MenuType} from "../../../models";

@Component({
    selector: 'select-box',
    templateUrl: './select-box.component.html',
    styleUrls: ['./select-box.component.scss']
})
export class SelectBoxComponent  implements AfterViewInit, OnInit {
    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
        public inputBox: InputBoxService,
    ) {
    }

    ngOnInit() {
        const elementVal = this.control.elementVal.getValue() as MenuElementType15;
        this.inputBox.getSelectBox(elementVal.params.value)
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
